import { Module } from '@nestjs/common'
import { CustomerMenuController, MenuController } from './controllers'
import { CategoryService, MenuItemService } from './services'

@Module({
	controllers: [MenuController, CustomerMenuController],
	providers: [CategoryService, MenuItemService],
})
export class MenuModule {}
